// @flow

import * as React from 'react';

import { connect } from 'react-redux';

import {
  setCartReselleeId as setCartCustomer,
  setCartProductOwner,
} from '@gandi/cart';

type Props = {
  resetCartCustomer: () => void,
  resetCartProductsOwner: () => void,
};

function ResellerSelfSelect({
  resetCartCustomer,
  resetCartProductsOwner,
}: Props) {
  /* ----------- Reset possibly conflicting cart ownership state. ----------- */
  // Required to prevent possible desync cases when user selects a product owner
  // for the cart, then change their mind a select a customer.
  React.useEffect(() => {
    resetCartCustomer();
    resetCartProductsOwner();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* ------------------------------------------------------------------------ */

  return null;
}

const mapDispatchToProps = {
  resetCartCustomer: setCartCustomer.bind(null, null),
  resetCartProductsOwner: setCartProductOwner.bind(null, null),
};

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(null, mapDispatchToProps)(ResellerSelfSelect);
